// extracted by mini-css-extract-plugin
export default {"placeholder":"PlaceholderImage_placeholder__yLxgf","bgPan":"PlaceholderImage_bgPan__Zaomb"};